import { render, staticRenderFns } from "./sky-media.vue?vue&type=template&id=5be789fa&scoped=true"
import script from "./sky-media.vue?vue&type=script&lang=js"
export * from "./sky-media.vue?vue&type=script&lang=js"
import style0 from "./sky-media.vue?vue&type=style&index=0&id=5be789fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be789fa",
  null
  
)

export default component.exports